var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiLessThan600Calories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#e3fb94",
    opacity: 0.5,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.879 9.2C11.417 7.578 12.53 6 12.53 6c-2.393 1.368-2.922 3.456-2.336 6.096-.862-.694-.987-1.516-.959-2.6-1.098 1.166-1.295 2.4-1.223 3.736a3.954 3.954 0 001.245 2.683A4.01 4.01 0 0012.025 17a4.009 4.009 0 002.754-1.115 3.954 3.954 0 001.215-2.697c.084-1.746-.661-3.03-2.115-3.988zm-1.612 6.88a2.78 2.78 0 01-1.545-.461 3.582 3.582 0 002.838-1.026 3.532 3.532 0 001.026-2.82 2.73 2.73 0 01.26 2.588 2.78 2.78 0 01-1.514 1.506c-.34.14-.703.213-1.07.214z",
    fill: "#31544e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.041 3.706L4.706 20.959",
    stroke: "#31544e",
    strokeLinecap: "round"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--less-than-600-calories-ee15776cb64549e9b4bbcd3714806d4d.svg";
export { SvgIconUiLessThan600Calories as Component };